var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1837_2618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.978 4.68632L8.67339 4.37384C8.46507 4.35491 8.28506 4.22234 8.19993 4.02349L7.01631 1.1544C6.82693 0.680955 6.15453 0.680955 5.96515 1.1544L4.79099 4.02349C4.71524 4.22234 4.52586 4.35491 4.31754 4.37384L1.01285 4.68632C0.520461 4.73367 0.321612 5.34915 0.690904 5.68056L3.18126 7.86789C3.34223 8.00992 3.40851 8.21824 3.36117 8.42655L2.61312 11.4944C2.49949 11.9774 3.02028 12.375 3.45586 12.1194L6.21134 10.5002C6.39126 10.396 6.60904 10.396 6.78896 10.5002L9.54454 12.1194C9.98011 12.375 10.5009 11.9869 10.3872 11.4944L9.6486 8.42655C9.60125 8.21824 9.66754 8.00992 9.82851 7.86789L12.3189 5.68056C12.6787 5.34915 12.4704 4.73367 11.978 4.68632Z",
    fill: "#F59E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1837_2618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9c222587b6c5d4e3b75a34f687d22445.svg";
export { ForwardRef as ReactComponent };